// extracted by mini-css-extract-plugin
export var container = "_iu-0";
export var content = "_iu-3";
export var customerTitle = "_iu-4";
export var empty = "_iu-5";
export var gray = "_iu-6";
export var header = "_iu-7";
export var info = "_iu-8";
export var loading = "_iu-2";
export var loadingCard = "_iu-9";
export var oneLine = "_iu-a";
export var personName = "_iu-e";
export var pillContainer = "_iu-b";
export var selected = "_iu-1";
export var text = "_iu-c";
export var twoLines = "_iu-d";
export var unread = "_iu-f";
export var unreadIndicator = "_iu-g";